// extracted by mini-css-extract-plugin
export default {"carrusel":"NuevoCarrusel_carrusel__iiwI6","carruselitems":"NuevoCarrusel_carruselitems__uFwmy","carruselitem":"NuevoCarrusel_carruselitem__8O7aZ"};